import nodeService from "@/services/nodejs"

const logoutRequest = (state, payload) => {

    return new Promise(resolve => {
        state.commit("AUTH_LOGOUT")
        state.commit('SET_ACCESS_TOKEN', "");
        resolve()
    });
}

const loginRequest = async (state, payload) => {
    let errorObj = { error: "", message: "" };

    return new Promise((resolve, reject) => {
        state.commit("AUTH_REQUEST");

        nodeService.loginv2(payload.username, payload.password)
            .then(response => {
                state.commit("AUTH_SUCCESS_NODE", response.data)
                const uuid = response.data.uuid
                fetchUserDetails(state, uuid)

                resolve(true)
            })
            .catch(err => {
                var StringError = String(err)

                errorObj.message = "usuario ou senha incorretos"

                if (StringError.includes("Network")) {
                    errorObj.message = "Erro. Tente novamente mais tarde"
                }

                errorObj.error = err
                state.commit("AUTH_ERROR", err)
                reject(errorObj);
            });
    });
}

async function fetchUserDetails(state, uuid) {
    await nodeService.getUserDetails(uuid)
    .then(response => {
            state.commit("SET_USER_DETAILS", response.data)
        })
        .catch(err => {
            state.commit("AUTH_ERROR", err)
        })
}

const loginGoogleRequest = (state, payload) => {
    let errorObj = { error: "", message: "" };

    return new Promise((resolve, reject) => {
        state.commit("AUTH_REQUEST");

        nodeService.loginGoogle(payload.authCode, payload.pid)
            .then(rspNode => {
                resolve(true);
            })
            .catch(err => {
                var StringError = String(err);
                errorObj.message = "usuario ou senha incorretos";

                if (StringError.includes("Network")) {
                    errorObj.message = "Erro. Tente novamente mais tarde";
                }

                errorObj.error = err;
                state.commit("AUTH_ERROR", err);
                reject(errorObj);
            });
    })
}

export default {
    logoutRequest,
    loginRequest,
    loginGoogleRequest,
    fetchUserDetails,
}